import { render } from "./NoUserDesktopNav.vue?vue&type=template&id=4c605ccc"
import script from "./NoUserDesktopNav.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./NoUserDesktopNav.vue?vue&type=script&charset=utf-8&lang=js"
script.render = render

export default script